<!-- RecurrenceAccordion.vue -->
<template>
    <div class="ppv2-border ppv2-border-black ppv2-border-opacity-[8%] ppv2-rounded-xl ppv2-overflow-hidden">
        <button
            type="button"
            class="ppv2-bg-black ppv2-bg-opacity-[3%] hover:ppv2-bg-opacity-[6%] ppv2-w-full ppv2-px-4 ppv2-py-3 ppv2-flex ppv2-items-center ppv2-justify-between ppv2-text-sm poppinsMedium ppv2-text-black ppv2-rounded-xl ppv2-transition-all ppv2-duration-200"
            :class="{ 'ppv2-rounded-b-none': isOpen }"
            @click="toggleOpen"
        >
            <span>{{ $t('staff_planning_v3.components.absence_modal.add_recurrence') }}</span>
            <ChevronDown
                :size="16"
                class="ppv2-text-[#A0A4AE] ppv2-transition-transform ppv2-duration-300"
                :class="{ 'ppv2-rotate-180 ppv2-text-purple': isOpen }"
            />
        </button>

        <div v-show="isOpen" class="ppv2-p-4 ppv2-border-t ppv2-border-black ppv2-border-opacity-[8%] ppv2-space-y-3">
            <div class="ppv2-flex ppv2-items-start ppv2-gap-4 ppv2-mb-3">
                <!-- Frequency -->
                <div class="ppv2-flex-1">
                    <label
                        class="ppv2-block ppv2-text-[11px] poppinsBold ppv2-tracking-wider ppv2-text-[#94A3B8] ppv2-uppercase ppv2-mb-1.5"
                    >
                        {{ $t('staff_planning_v3.components.absence_modal.frequency') }}
                    </label>
                    <BaseSelect
                        :value="frequency"
                        @input="$emit('update:frequency', $event)"
                        :options="frequencyOptions"
                        fixed-dropdown
                    />
                </div>

                <!-- Recurrence end date -->
                <div class="ppv2-flex-1">
                    <BaseDateInput
                        :value="recurrenceEndDate"
                        @input="$emit('update:recurrenceEndDate', $event)"
                        :label="$t('staff_planning_v3.components.absence_modal.recurrence_end')"
                        placeholder="JJ/MM/YYYY"
                        customLabelClass="!ppv2-text-[#A09DBC]"
                        :customSizeLabel="11"
                    />
                </div>
            </div>

            <!-- Days -->
            <p class="ppv2-text-xs ppv2-text-black ppv2-text-opacity-50">{{ chooseDaysText }}</p>
            <div class="ppv2-flex ppv2-gap-2">
                <BaseCircleButton
                    v-for="day in days"
                    :key="day.id"
                    :active="selectedDays.includes(day.id)"
                    @click="$emit('toggle-day', day.id)"
                >
                    {{ day.label }}
                </BaseCircleButton>
            </div>
        </div>
    </div>
</template>

<script>
import { ChevronDown } from 'lucide-vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BaseDateInput from '../../../Shared/BaseDateInput.vue'
import BaseCircleButton from '../../../Shared/BaseCircleButton.vue'

export default {
    name: 'RecurrenceAccordion',

    components: { ChevronDown, BaseSelect, BaseDateInput, BaseCircleButton },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        frequency: {
            type: String,
            default: null,
        },
        recurrenceEndDate: {
            type: String,
            default: null,
        },
        selectedDays: {
            type: Array,
            default: () => [],
        },
        days: {
            type: Array,
            default: () => [],
        },
        frequencyOptions: {
            type: Array,
            default: () => [],
        },
        chooseDaysText: {
            type: String,
            default: '',
        },
    },

    emits: ['input', 'update:frequency', 'update:recurrenceEndDate', 'toggle-day', 'update:isOpen'],

    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    methods: {
        toggleOpen() {
            const next = !this.value
            this.$emit('input', next)
            this.$emit('update:isOpen', next)
        },
    },
}
</script>
